import { connect } from "react-redux";
import { PagePassword } from "senac-components";
import { userSlice, commonSlice } from "../store/reducers";
import { RootState, AppDispatch } from "../store";
import {
  PagePasswordDispatch,
  PagePasswordProps,
  PagePasswordStateProps,
} from "senac-components/dist/pages/Mobile/PagePassword";

import { PagePasswordWeb } from "senac-components/dist/pages/Web/PagePassword";

import { MenuOptions } from "senac-components/dist/pages/Mobile/PageInterfaces";

const mapState = (state: RootState) => {
  let result: PagePasswordStateProps = {
    loading: state.userState.userAuthenticating,
  };

  return result;
};

const mapDispatch = (dispatch: AppDispatch) => {
  const result: PagePasswordDispatch = {
    onClickNext: (password: string) => {
      dispatch(userSlice.actions.signin(password));
    },
    onClickCollection: () => {
      dispatch(commonSlice.actions.goToPage(MenuOptions.Home));
    },
    onClickForgotMyPassword: () => {
      dispatch(commonSlice.actions.recoverPassword());
    },
    onClickBack: () => {
      dispatch(commonSlice.actions.loginPage());
    },
  };

  return result;
};

const WPagePassword = () => {
  const Mobile = connect(mapState, mapDispatch)(PagePassword);
  const Web = connect(mapState, mapDispatch)(PagePasswordWeb);
  if (window.innerWidth < 1024) return <Mobile />;
  return <Web />;
};

export { WPagePassword };
